type WaveDividerProps = {
  /** Tailwind bg-* class for the section above (sets the divider container background). */
  from: string;
  /** CSS color value (e.g. `var(--color-cream)`) for the wave fill — the section below's color. */
  to: string;
  /** Flip the wave vertically. */
  flip?: boolean;
  height?: number;
  className?: string;
};

/**
 * Soft balance wave between two color bands. Renders as a decorative SVG
 * the same width as the page; aria-hidden. The two wave paths drift slowly
 * in opposing directions for a subtle "breathing" flow effect.
 */
export function WaveDivider({
  from,
  to,
  flip = false,
  height = 72,
  className = "",
}: WaveDividerProps) {
  return (
    <div
      aria-hidden="true"
      className={`${from} ${className} block overflow-hidden leading-[0]`}
      style={{
        transform: flip ? "scaleY(-1)" : undefined,
        marginBottom: -1,
      }}
    >
      <svg
        viewBox="0 0 1440 82"
        preserveAspectRatio="none"
        className="block w-full"
        style={{ height, display: "block" }}
      >
        {/* back wave (softer) — duplicated cycle, drifts left→right */}
        <path
          className="wave-anim-a"
          d="M0,40 C240,80 480,0 720,32 C960,64 1200,72 1440,40 C1680,8 1920,72 2160,40 C2400,8 2640,72 2880,40 L2880,82 L0,82 Z"
          fill={to}
          opacity="0.35"
        />
        {/* front wave — duplicated cycle, drifts right→left */}
        <path
          className="wave-anim-b"
          d="M0,52 C240,16 480,72 720,48 C960,24 1200,64 1440,44 C1680,24 1920,64 2160,44 C2400,24 2640,64 2880,44 L2880,82 L0,82 Z"
          fill={to}
        />
      </svg>
    </div>

  );
}
